import { useMemo } from "react";
import { useBalance as _useBalance, useAccount, useContractRead } from "wagmi";
import { useWeb3Ts } from "../context/Web3TsContext";
import { NumberFormater } from "../utils/formater/NumberFormater";
export const useBalance = () => {
 const { address } = useAccount();
 const { data: balanceRequest } = _useBalance({
  address,
 });
 const balance = useMemo(() => {
  if (balanceRequest)
   return NumberFormater.roundUp(Number(balanceRequest.formatted), 4);
  return 0;
 }, [balanceRequest]);
 const web3TsConfig = useWeb3Ts();
 const { data: balanceTokenRequest } = useContractRead({
  watch: true,
  address: web3TsConfig.config.mainContract.contractAddress as `0x${string}`,
  abi: [
   {
    inputs: [
     {
      internalType: "address",
      name: "account",
      type: "address",
     },
    ],
    name: "balanceOf",
    outputs: [
     {
      internalType: "uint256",
      name: "",
      type: "uint256",
     },
    ],
    stateMutability: "view",
    type: "function",
   },
  ],
  functionName: "balanceOf",
  args: [address],
 });
 const balanceToken = useMemo(() => {
  if (balanceTokenRequest)
   return NumberFormater.roundUp(Number(balanceTokenRequest) / 1e18, 4);
  return 0;
 }, [balanceTokenRequest]);
 return {
  balance,
  balanceToken,
 };
};
